import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function BackendDeveloperSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["backend-developer"]} />;
}
